module.exports = __webpack_public_path__ + "img/header-ccc_mobile@2x.8d15807.webp";